export default function initParallax() {
    const elements = document.querySelectorAll('[data-parallax]');

    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        // Get settings from data attributes with defaults
        const speed = parseFloat(element.dataset.parallaxSpeed) || 0.5;
        const direction = element.dataset.parallaxDirection || 'down'; // 'down' or 'up'

        let ticking = false;

        const applyParallax = () => {
            const scrolled = window.pageYOffset;

            // Simple calculation: just use scroll position
            const offset = scrolled * speed;
            const transformValue = direction === 'up' ? -offset : offset;

            element.style.transform = `translateY(${transformValue}px)`;

            ticking = false;
        };

        const onScroll = () => {
            if (!ticking) {
                window.requestAnimationFrame(applyParallax);
                ticking = true;
            }
        };

        // Initial call
        applyParallax();

        // Attach scroll listener
        window.addEventListener('scroll', onScroll, { passive: true });

        // Recalculate on resize
        window.addEventListener('resize', () => {
            applyParallax();
        }, { passive: true });
    });
}
